<template>
  <div class="application-confirmation-page">
    <div class="col-md-12 no-padd m-b-lg">
      <div class="b-light bg-white">
        <div class="container">
          <ul class="h5 breadcrumb no-border bg-empty m-b-none m-l-n-sm bg-sub-menu">
            <li>
              <a href="#">การขาย</a>
            </li>
            <li class="active">
              <span class="text-success h4">
                ใบคำขอใหม่
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="application-content-section">
      <div class="title-text">สรุปข้อมูลใบคำขอ</div>

      <Panel class="insured-information-container" title="ข้อมูลของผู้ขอเอาประกันภัย">
        <div class="insured-information">
          <div class="information-name">เลขบัตรประจำตัวประชาชน :</div>
          <div class="information-value">{{ insuredInformation.identityNumber }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">ชื่อ-นามสกุล :</div>
          <div class="information-value">{{ insuredInformation.name }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">วัน/เดือน/ปีเกิด :</div>
          <div class="information-value">{{ insuredInformation.dob }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">อายุ :</div>
          <div class="information-value">{{ insuredInformation.age }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">อีเมล :</div>
          <div class="information-value">{{ insuredInformation.email }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">โทรศัพท์บ้าน :</div>
          <div class="information-value">{{ insuredInformation.homeTel }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">โทรศัพท์มือถือ :</div>
          <div class="information-value">{{ insuredInformation.mobileTel }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">น้ำหนัก :</div>
          <div class="information-value">{{ insuredInformation.weight }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">ส่วนสูง :</div>
          <div class="information-value">{{ insuredInformation.height }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">เพศ :</div>
          <div class="information-value">{{ insuredInformation.gender }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">อาชีพ :</div>
          <div class="information-value">{{ insuredInformation.occupation }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">ที่อยู่ตามทะเบียนบ้าน: :</div>
          <div class="information-value">{{ insuredInformation.mainAddress }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">การจัดส่งกรมธรรม์ :</div>
          <div class="information-value">{{ insuredInformation.deliveryAddress }}</div>
        </div>
      </Panel>

      <Panel class="health-information-container" title="ข้อแถลงสุขภาพของผู้เอาประกันภัย">
        <div class="health-information">
          <span class="information-name">
            1. ท่านมีประกันชีวิต ประกันภัยสุขภาพ ประกันภัยโรคร้ายแรง โรคมะเร็ง
            หรือประกันภัยอุบัติเหตุ กับบริษัท ประกันภัยไทยวิวัฒน์ หรือบริษัทอื่นหรือไม่?
          </span>
          <span class="information-value">{{ healthInformation[0] }}</span>
        </div>
        <div class="health-information">
          <span class="information-name">
            2. ท่านเคยถูกปฏิเสธการขอเอาประกันชีวิต ประกันสุขภาพ ประกันภัยโรคร้ายแรง
            ประกันภัยอุบัติเหตุส่วนบุคคล หรือถูกปฏิเสธการต่ออายุสัญญาประกันภัย
            หรือถูกเรียกเก็บเบี้ยประกันภัยเพิ่ม หรือเปลี่ยนแปลงเงื่อนไข
            สำหรับการประกันภัยดังกล่าวหรือไม่
          </span>
          <span class="information-value">{{ healthInformation[1] }}</span>
        </div>
        <div class="health-information">
          <span class="information-name">
            3. ท่านเคยได้รับเชื้อ หรือมีอาการ หรือเคยได้รับการรักษา หรือขณะนี้รับการรักษาอยู่
            หรือเคยได้รับการบอกเล่า จากแพทย์ด้วยโรคมะเร็ง เนื้องอกโรคสมอง/หลอดเลือดสมอง (Stoke)
            โรคตับ โรคเอดส์หรือมีเลือดบวกต่อไวรัส HIV โรคเบาหวาน โรคไต โรคหัวใจ/หลอดเลือด
            ความดันโลหิตสูง ไขมันในเลือดสูง โรคปอด โรคเลือด โรคถุงลม โป่งพอง ลำไส้อักเสบเรื้อรัง
            โรคทางระบบประสาท อัมพาต โรคกระดูกกระดูกสันหลัง โรคกล้ามเนื้อหรือโรคประจำตัว
            หรือมีความพิการ หรือโรคร้ายแรงอื่นๆ (รวมถึงการได้รับการรักษาแบบผู้ป่วยนอก)
          </span>
          <span class="information-value">{{ healthInformation[2] }}</span>
        </div>
        <div class="health-information">
          <span class="information-name">
            4. ท่านเคยได้รับคำแนะนำจากแพทย์ให้เข้ารับการรักษาจากการบาดเจ็บ การเจ็บป่วย
            หรือเข้ารับการผ่าตัด หรือมีโรคที่ ต้องอยู่ในความดูแลเป็นประจำของแพทย์
            หรือเข้ารับการตรวจวินิจฉัยโรค เช่น การอัลตร้าซาวด์ เอ็กซเรย์ คอมพิวเตอร์
            การตรวจด้วยคลื่นแม่เหล็กไฟฟ้า การส่งตรวจชิ้นเนื้อทางด้านพยาธิวิทยา การตรวจคลื่นหัวใจ
            การตรวจเลือด ตรวจปัสสาวะ/อุจจาระ หรือไม่ (รวมถึงการได้รับการรักษาแบบผู้ป่วยนอก)
          </span>
          <span class="information-value">{{ healthInformation[3] }}</span>
        </div>
        <div class="health-information">
          <span class="information-name">
            5. บิดา มารดา และ/หรือพี่น้อง ของผู้ขอเอาประกันภัยเคยได้รับการวินิจฉัยว่าป่วยเป็น
            หรือเสียชีวิตเนื่องจาก โรคหัวใจ/หลอดเลือด โรคมะเร็ง โรคสมอง/หลอดเลือดสมอง (Stroke)
            โรคตับ โรคเอดส์ วัณโรคหรือไม่?
          </span>
          <span class="information-value">{{ healthInformation[4] }}</span>
        </div>
      </Panel>

      <Panel
        class="insurance-package-information-container"
        title="แผนประกันภัยและความคุ้มครองที่เลือก"
      >
        <div class="insurance-package-information">
          <div class="information-name">วันที่เริ่มต้นคุ้มครอง วัน/เดือน/ปี :</div>
          <div class="information-value">{{ insurancePackageInformation.policyStartDate }}</div>
        </div>
        <div class="insurance-package-information">
          <div class="information-name">ชื่อกรมธรรม์ประกันภัย :</div>
          <div class="information-value">ttb health care plus</div>
        </div>
        <div class="insurance-package-information">
          <div class="information-name">แผนความคุ้มครอง :</div>
          <div class="information-value">{{ insurancePackageInformation.planName }}</div>
        </div>
        <div class="insurance-package-information">
          <div class="information-name">ผลประโยชน์เพิ่มเติม :</div>
          <div class="information-value">{{ insurancePackageInformation.coverageCode }}</div>
        </div>
      </Panel>

      <Panel class="beneficiary-information-container" title="รายละเอียดผู้รับผลประโยชน์">
        <div class="beneficiary-information" v-if="!isBeneficiaryLegalHeir">
          <div class="information-name">ชื่อ-นามสกุล :</div>
          <div class="information-value">
            {{ beneficiaryInformation.beneficiaryFirstPersonName }}
          </div>
        </div>
        <div class="beneficiary-information" v-if="!isBeneficiaryLegalHeir">
          <div class="information-name">ความสัมพันธ์กับผู้เอาประกันภัย :</div>
          <div class="information-value">
            {{ beneficiaryInformation.beneficiaryFirstPersonRelationship }}
          </div>
        </div>
        <div class="beneficiary-information" v-if="!isBeneficiaryLegalHeir">
          <div class="information-name">สัดส่วน :</div>
          <div class="information-value">
            {{ beneficiaryInformation.beneficiaryFirstPersonPercentagep }}
          </div>
        </div>
        <div class="beneficiary-information" v-if="!isBeneficiaryLegalHeir">
          <div class="information-name">ชื่อ-นามสกุล :</div>
          <div class="information-value">
            {{ beneficiaryInformation.beneficiarySecondPersonName }}
          </div>
        </div>
        <div class="beneficiary-information" v-if="!isBeneficiaryLegalHeir">
          <div class="information-name">ความสัมพันธ์กับผู้เอาประกันภัย :</div>
          <div class="information-value">
            {{ beneficiaryInformation.beneficiarySecondPersonRelationship }}
          </div>
        </div>
        <div class="beneficiary-information" v-if="!isBeneficiaryLegalHeir">
          <div class="information-name">สัดส่วน :</div>
          <div class="information-value">
            {{ beneficiaryInformation.beneficiarySecondPersonPercentagep }}
          </div>
        </div>
        <div class="beneficiary-information" v-if="isBeneficiaryLegalHeir">
          <div class="information-name"></div>
          <div class="information-value">
            ทายาทตามกฎหมาย
          </div>
        </div>
      </Panel>

      <Panel class="foreign-information-container" title="สำหรับชาวต่างชาติ" v-if="isForeigner">
        <div class="foreign-information">
          <div class="information-name">ถิ่นที่อยู่ในประเทศไทย :</div>
          <div class="information-value">{{ foreignerResidentialInformation }}</div>
        </div>
      </Panel>

      <Panel class="payment-information-container" title="วิธีชำระเบี้ยประกัน">
        <div class="payment-information">
          <div class="information-name">ผู้ชำระเบี้ยประกันภัย :</div>
          <div class="information-value">{{ paymentMethodInformation.name }}</div>
        </div>
        <div class="payment-information" v-if="checkPayerRelationshipCondition">
          <div class="information-name">ความสัมพันธ์กับผู้เอาประกันภัย :</div>
          <div class="information-value">
            {{ paymentMethodInformation.payerRelationship }}
          </div>
        </div>
        <div class="payment-information">
          <div class="information-name">ช่องทางการชำระ :</div>
          <div class="information-value">
            <div>{{ paymentMethodInformation.paymentMethod }}</div>
            <div v-if="isDirectDebitPayment">
              เลขที่: {{ paymentMethodInformation.directDebitPayment.accountNumber }}
            </div>
            <div v-if="isDirectDebitPayment">
              ชื่อบัญชี: {{ paymentMethodInformation.directDebitPayment.accountName }}
            </div>
            <div v-if="isDirectDebitPayment">
              Product code: {{ paymentMethodInformation.directDebitPayment.accountProductCode }}
            </div>
          </div>
        </div>
        <div class="payment-information">
          <div class="information-name">วิธีชำระเบี้ยประกันปีต่ออายุ กรมธรรม์ถัดไป :</div>
          <div class="information-value">{{ paymentMethodInformation.isAutoRenew }}</div>
        </div>
      </Panel>

      <Panel
        class="tax-information-container"
        title="สิทธิ์ขอยกเว้นภาษีเงินได้ (กรณีซื้อให้ตัวเอง/บิดา มารดา)"
      >
        <div class="tax-information">
          <div class="information-name">ใช้สิทธิ์ขอยกเว้นภาษีเงินได้ :</div>
          <div class="information-value">{{ taxInformation }}</div>
        </div>
      </Panel>

      <div class="insurance-premium-information-container">
        <div class="insurance-premium-information">
          <div class="information-name">ค่าเบี้ยสุทธิ (IPD+PA)</div>
          <div class="information-value">
            {{ insurancePremiumInformation.grossPremium | formatNumber }} บาท
          </div>
        </div>
        <div class="insurance-premium-information">
          <div class="information-name">
            ส่วนลดเบี้ยประกันภัยสำหรับการติดเงื่อนไขความรับผิดส่วนแรก (Deductible-DD)
            สำหรับค่าห้องและค่ารักษาพยาบาลผู้ป่วยใน (DD{{
              insurancePremiumInformation.deductAmount | formatNumber
            }})
          </div>
          <div class="information-value">
            {{ insurancePremiumInformation.deductDiscount | formatNumber }} บาท
          </div>
        </div>
        <div class="insurance-premium-information" v-if="isFamily">
          <div class="information-name">
            ส่วนลดเบี้ยประกันภัยสำหรับครอบครัว (ได้รับส่วนลด
            {{ insurancePremiumInformation.familyDiscountPercentage }}%)
          </div>
          <div class="information-value">
            {{ insurancePremiumInformation.familyDiscount | formatNumber }} บาท
          </div>
        </div>
        <div class="insurance-premium-information summary-information">
          <div class="information-name">รวมเบี้ยประกันภัยที่ต้องชำระ</div>
          <div class="information-value">
            {{ insurancePremiumInformation.netPremium | formatNumber }} บาท
          </div>
        </div>
      </div>

      <div class="application-confirmation-button-container">
        <div class="edit-info-button">
          <Button theme="outline" @click.native="editApplicationInformation">แก้ไขข้อมูล</Button>
        </div>
        <div class="submit-info-button">
          <Button @click.native="submitApplicationInformation">ยืนยันข้อมูล</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import moment from 'moment'
import _ from 'lodash'

import Button from '@/components/Button'
import Panel from '@/components/Panel'
import { DATE_FORMAT } from '@/lib/global'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

const { mapFields: mapPaymentFields } = createHelpers({
  getterType: 'getPaymentFields',
  mutationType: 'updatePaymentFields',
})

export default {
  name: 'AppplicationConfirmation',
  props: ['application_id'],
  mounted() {
    this.getApplicationInformation(this.application_id)
  },
  computed: {
    ...mapApplicationFields({
      applicationData: 'data.applicationInformation',
      applicationValidationErrors: 'validation.errors',
      tmbMethodInformation: 'data.paymentMethod.tmbMethodInformation',
    }),
    ...mapPaymentFields({
      paymentInformation: 'paymentInformation.data',
    }),
    insuredInformation() {
      const identityNumber = _.get(this.applicationData, 'insuredPerson.identityNumber')
      const namePrefix = _.get(this.applicationData, 'insuredPerson.title.name') || ''
      const firstname = _.get(this.applicationData, 'insuredPerson.firstname') || ''
      const lastname = _.get(this.applicationData, 'insuredPerson.lastname') || ''
      const dob = moment(_.get(this.applicationData, 'insuredPerson.birthDate'))
        .add(543, 'years')
        .format(DATE_FORMAT)
      const age = _.get(this.applicationData, 'insuredPerson.age')
      const email = _.get(this.applicationData, 'insuredPerson.email')
      const homeTel = _.get(this.applicationData, 'insuredPerson.mainHomeTel')
      const mobileTel = _.get(this.applicationData, 'insuredPerson.mainMobileTel')
      const weight = _.get(this.applicationData, 'insuredPerson.weight')
      const height = _.get(this.applicationData, 'insuredPerson.height')
      const gender = _.get(this.applicationData, 'insuredPerson.sex') === 'M' ? 'ชาย' : 'หญิง'
      const occupation = _.get(this.applicationData, 'insuredPerson.occupation.nameTh')
      const isDeliveryPostalMethod =
        _.get(this.applicationData, 'application.deliveryMethod') === 'postal'

      return {
        name: `${namePrefix}${firstname} ${lastname}`.trim(),
        identityNumber,
        dob,
        age,
        email,
        homeTel,
        mobileTel,
        weight,
        height,
        gender,
        occupation,
        mainAddress: this.manipulatedMainAddressData(),
        deliveryAddress: isDeliveryPostalMethod ? this.manipulatedDeliveryAddressData() : email,
      }
    },
    healthInformation() {
      const healthAnswers = _.chain(this.applicationData)
        .get('application.healthAnswers', '')
        .split(',')
        .map(answer => {
          if (parseInt(answer, 10)) {
            return 'ใช่'
          }

          return 'ไม่ใช่'
        })
        .value()

      return healthAnswers
    },
    beneficiaryInformation() {
      // beneficiary first person information
      const firstPersonNamePrefix =
        _.get(this.applicationData, 'beneficiaryPerson1.title.name') || ''
      const firstPersonFirstname = _.get(this.applicationData, 'beneficiaryPerson1.firstname') || ''
      const firstPersonLastname = _.get(this.applicationData, 'beneficiaryPerson1.lastname') || ''
      const firstPersonRelationship = _.get(
        this.applicationData,
        'application.beneficiaryPersonRelationship1.description',
      )
      const firstPersonRatioPercentage = _.get(
        this.applicationData,
        'application.beneficiaryPersonPercentage1',
      )

      // beneficiary second person information
      const secondPersonNamePrefix =
        _.get(this.applicationData, 'beneficiaryPerson2.title.name') || ''
      const secondPersonFirstname =
        _.get(this.applicationData, 'beneficiaryPerson2.firstname') || ''
      const secondPersonLastname = _.get(this.applicationData, 'beneficiaryPerson2.lastname') || ''
      const secondPersonRelationship = _.get(
        this.applicationData,
        'application.beneficiaryPersonRelationship2.description',
      )
      const secondPersonRatioPercentage = _.get(
        this.applicationData,
        'application.beneficiaryPersonPercentage2',
      )

      return {
        beneficiaryFirstPersonName: `${firstPersonNamePrefix}${firstPersonFirstname} ${firstPersonLastname}`.trim(),
        beneficiaryFirstPersonRelationship: firstPersonRelationship,
        beneficiaryFirstPersonPercentagep: firstPersonRatioPercentage,
        beneficiarySecondPersonName: `${secondPersonNamePrefix}${secondPersonFirstname} ${secondPersonLastname}`.trim(),
        beneficiarySecondPersonRelationship: secondPersonRelationship,
        beneficiarySecondPersonPercentagep: secondPersonRatioPercentage,
      }
    },
    insurancePackageInformation() {
      const planName = _.get(this.applicationData, 'planPackageScheme.planName')
      const coverageCode = _.chain(this.applicationData)
        .get('planPackageScheme.coverageCode')
        .replace(/\+/g, ', ')
        .value()

      const policyStartDate = moment(_.get(this.applicationData, 'application.policyStartDate'))
        .add(543, 'years')
        .format(DATE_FORMAT)

      return {
        planName,
        coverageCode,
        policyStartDate,
      }
    },
    foreignerResidentialInformation() {
      const foreignerHasThailandResidency = _.get(
        this.applicationData,
        'application.foreignerHasThailandResidency',
        false,
      )

      if (!foreignerHasThailandResidency) {
        const foreignerCountryResidency =
          _.get(this.applicationData, 'application.foreignerCountryResidency.country_name_th') || ''

        return `ไม่มี, ${foreignerCountryResidency}`
      }

      return 'มี'
    },
    paymentMethodInformation() {
      const namePrefix = _.get(this.applicationData, 'payer.title.name') || ''
      const firstname = _.get(this.applicationData, 'payer.firstname') || ''
      const lastname = _.get(this.applicationData, 'payer.lastname') || ''

      const payerRelationship = _.get(
        this.applicationData,
        'application.payerRelationshipId.description',
      )
      const paymentMethod = _.get(this.paymentInformation, 'paymentTypeDesc')
      const accountNumber = _.get(this.paymentInformation, 'detail.accountNumber') || ''
      const accountName = _.get(this.paymentInformation, 'detail.accountName') || ''
      const accountProductCode = _.get(this.paymentInformation, 'detail.accountProductCode') || ''
      const isAutoRenew = _.get(this.applicationData, 'application.isAutoRenew', false)

      return {
        name: `${namePrefix}${firstname} ${lastname}`.trim(),
        payerRelationship,
        paymentMethod,
        directDebitPayment: {
          accountNumber: accountNumber.substring(4),
          accountName,
          accountProductCode,
        },
        isAutoRenew: isAutoRenew ? 'ประสงค์ต่ออายุอัติโนมัติ' : 'ไม่ประสงค์ต่ออายุอัติโนมัติ',
      }
    },
    taxInformation() {
      return _.get(this.applicationData, 'application.isAllowTaxExemption', false)
        ? 'มีความประสงค์'
        : 'ไม่มีความประสงค์'
    },
    insurancePremiumInformation() {
      const grossPremium = _.get(this.applicationData, 'pricing.grossPremium', 0)
      const deductAmount = _.get(this.applicationData, 'deductible.deduct', 0)
      const deductDiscount = _.get(this.applicationData, 'deductible.discount', 0)
      const familyDiscountPercentage = _.get(
        this.applicationData,
        'pricing.familyDiscountPercentage',
        0,
      )
      const familyDiscount = _.get(this.applicationData, 'pricing.familyDiscount', 0)
      const netPremium = _.get(this.applicationData, 'pricing.netPremium', 0)

      return {
        grossPremium,
        deductAmount,
        deductDiscount,
        familyDiscountPercentage,
        familyDiscount,
        netPremium,
      }
    },
    isBeneficiaryLegalHeir() {
      return _.get(this.applicationData, 'quotation.isBeneficiaryLegalHeir', false)
    },
    isForeigner() {
      return _.get(this.applicationData, 'insuredPerson.identityTypeId', 1) === 2
    },
    isFamily() {
      return _.get(this.applicationData, 'familyQuotation.familyId')
    },
    isDirectDebitPayment() {
      return _.get(this.applicationData, 'payment.id', null) === 2
    },
    isFirstApplicationPerson() {
      const quotationId = _.get(this.applicationData, 'quotationId', null)
      const firstFamilyQuotationId = _.get(
        this.applicationData,
        'familyQuotation.quotations[0].quotationId',
        null,
      )

      return _.isEqual(quotationId, firstFamilyQuotationId)
    },
    checkPayerRelationshipCondition() {
      const isPaidByInsuredPerson = _.get(
        this.applicationData,
        'quotation.isPaidByInsuredPerson',
        false,
      )
      const isCombinePayment = _.get(
        this.applicationData,
        'familyQuotation.isCombinePayment',
        false,
      )

      if (this.isFirstApplicationPerson) {
        return !isPaidByInsuredPerson
      }

      return isCombinePayment || !isPaidByInsuredPerson
    },
  },
  components: {
    Button,
    Panel,
  },
  watch: {
    applicationData: {
      handler(data) {
        const paymentId = _.get(this.applicationData, 'payment.id', null)

        this.getPaymentInformation(this.application_id)
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['getApplicationInformation', 'getPaymentInformation']),
    manipulatedMainAddressData() {
      const mainAddress = _.get(this.applicationData, 'insuredPerson.mainAddress') || ''
      const mainSoiRoad = _.get(this.applicationData, 'insuredPerson.mainSoiRoad') || ''
      const mainTambon = _.get(this.applicationData, 'insuredPerson.mainTambon.name') || ''
      const mainAmphoe = _.get(this.applicationData, 'insuredPerson.mainAmphoe.name') || ''
      const mainProvince = _.get(this.applicationData, 'insuredPerson.mainProvince.name') || ''
      const mainPostcode = _.get(this.applicationData, 'insuredPerson.mainTambon.postcode') || ''

      return `${mainAddress} ${mainSoiRoad} ${mainTambon} ${mainAmphoe} ${mainProvince} ${mainPostcode}`.trim()
    },
    manipulatedDeliveryAddressData() {
      const deliveryAddress = _.get(this.applicationData, 'insuredPerson.deliveryAddress') || ''
      const deliverySoiRoad = _.get(this.applicationData, 'insuredPerson.deliverySoiRoad') || ''
      const deliveryTambon = _.get(this.applicationData, 'insuredPerson.deliveryTambon.name') || ''
      const deliveryAmphoe = _.get(this.applicationData, 'insuredPerson.deliveryAmphoe.name') || ''
      const deliveryProvince =
        _.get(this.applicationData, 'insuredPerson.deliveryProvince.name') || ''
      const deliveryPostcode =
        _.get(this.applicationData, 'insuredPerson.deliveryTambon.postcode') || ''

      return `${deliveryAddress} ${deliverySoiRoad} ${deliveryTambon} ${deliveryAmphoe} ${deliveryProvince} ${deliveryPostcode}`.trim()
    },
    editApplicationInformation() {
      if (this.isFamily) {
        window.location.href = `/application_family/${this.application_id}`
      }

      window.location.href = `/insurance_personal/${this.application_id}`
    },
    submitApplicationInformation() {
      return this.$router.push(`/consent/insured/${this.application_id}`)
    },
  },
}
</script>

<style lang="scss">
.application-confirmation-page {
  margin: 0 auto;
  width: 90%;

  .application-content-section {
    margin: 32px 0;

    .title-text {
      font-family: 'psl_kanda_extraregular';
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 24px;
      text-align: center;
    }

    .insured-information-container,
    .health-information-container,
    .insurance-package-information-container,
    .beneficiary-information-container,
    .foreign-information-container,
    .payment-information-container,
    .tax-information-container {
      margin-bottom: 32px;

      .panel-body {
        padding: 24px 24px 32px;
      }

      .information-name {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
      }

      .information-value {
        font-family: 'psl_kanda_extraregular';
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
      }
    }

    .insured-information-container {
      .insured-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .health-information-container {
      .health-information {
        margin-bottom: 16px;

        .information-value {
          margin-left: 8px;
        }
      }
    }

    .insurance-package-information-container {
      .insurance-package-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .beneficiary-information-container {
      .beneficiary-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .foreign-information-container {
      .foreign-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .payment-information-container {
      .payment-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .tax-information-container {
      .tax-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .insurance-premium-information-container {
      align-items: center;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 3px;
      box-shadow: 0 4px 20px 0 rgba(52, 73, 94, 0.2);
      margin-bottom: 32px;
      padding: 24px;

      .insurance-premium-information {
        display: grid;
        grid-template-columns: 4fr 1fr;
        grid-gap: 32px;

        &:not(:last-child) {
          margin-bottom: 16px;
        }

        .information-name {
          font-size: 16px;
          line-height: 24px;
        }

        .information-value {
          font-size: 16px;
          line-height: 24px;
          text-align: right;
        }

        &.summary-information {
          .information-name {
            font-family: 'psl_kanda_extraregular';
          }

          .information-value {
            color: #27ae60;
            font-family: 'psl_kanda_extraregular';
            font-size: 18px;
          }
        }
      }
    }

    .application-confirmation-button-container {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
